{
  "user": {
    "createFamilyForm": {
      "selectExistingMember": "Select an existing member",
      "missingMemberFromList": "Missing a member from the list?",
      "clickToAddNewMember": "Click here to add a new member",
      "backToExistingMembers": "Back to existing members",
      "fieldRequired": "This field is required.",
      "nameLabel": "Name *",
      "namePlaceholder": "Enter the name of this person",
      "emailLabel": "Email",
      "emailPlaceholder": "Enter an email for this person",
      "medicalConditionsLabel": "Medical Conditions",
      "preferredGenderPronounLabel": "Preferred Gender Pronoun",
      "dateOfBirthRequiredLabel": "Date of Birth *",
      "dateOfBirthLabel": "Date of Birth",
      "emergencyContactNameRequiredLabel": "Emergency Contact Name *",
      "emergencyContactNameLabel": "Emergency Contact Name",
      "emergencyContactNamePlaceholder": "Enter the emergency contact's name",
      "emergencyPhoneNumberRequiredLabel": "Emergency Phone Number *",
      "emergencyPhoneNumberLabel": "Emergency Phone Number",
      "emergencyContactPhonePlaceholder": "Enter the emergency contact's phone number",
      "secondaryMemberDescription": "The secondary member is who we will contact first if there is an issue with your account.",
      "denoteSecondaryMember": "Denote this member as the secondary member",
      "addMemberDetails": "Add member details",
      "basicInfo": "Basic Info",
      "dobRange": "Participant must have a date of birth between {max} and {min}.",
      "enterName": "Please enter a name",
      "enterValidEmail": "Please enter a valid email address",
      "enterEmergencyContactName": "Please enter an emergency contact name",
      "enterEmergencyContactPhone": "Please enter an emergency contact phone number"
    },
    "createFamilyModal": {
      "editMember": "Edit member",
      "addMember": "Add a member"
    },
    "modalFamilyInvite": {
      "inviteDescription": "Send {name} a link to create their own login. They'll be able to sign in and manage their own account.",
      "emailLabel": "Email",
      "invalidEmail": "Enter a valid email address.",
      "thisMember": "this member",
      "resendInvite": "Resend invite",
      "sendInvite": "Send invite",
      "inviteResent": "Invite resent.",
      "inviteSent": "Invite sent.",
      "sendInviteFailedRetry": "Failed to send invite. Please try again.",
      "sendInviteFailed": "Failed to send invite."
    },
    "familyCreate": {
      "basicInfo": "Basic Info",
      "fieldRequired": "This field is required.",
      "nameLabel": "Name *",
      "namePlaceholder": "Enter the name of this member",
      "emailLabel": "Email",
      "emailPlaceholder": "Enter the email of this member",
      "loginInviteDescription": "They'll get an email to create their own login. Requires an email above.",
      "sendLoginInvite": "Also send a login invite",
      "phoneNumberLabel": "Phone Number",
      "dateOfBirthLabel": "Date of Birth",
      "medicalConditionsLabel": "Medical Conditions",
      "genderPronounLabel": "Preferred Gender Pronoun",
      "additionalDetails": "Additional Details",
      "emergencyContactNameLabel": "Emergency Contact Name",
      "emergencyContactNamePlaceholder": "Enter the emergency contact's name",
      "emergencyPhoneNumberLabel": "Emergency Phone Number",
      "emergencyPhonePlaceholder": "Enter the emergency contact's phone number",
      "allergiesLabel": "Allergies",
      "allergiesPlaceholder": "Enter any allergies for this member",
      "secondaryMemberDescription": "The secondary member is who we will contact first if there is an issue with your account.",
      "denoteSecondaryMember": "Denote this member as the secondary member",
      "editTitle": "Edit Member",
      "createTitle": "Create Member",
      "memberSaved": "Member saved.",
      "inviteSent": "Invite sent.",
      "inviteFailed": "Member saved, but the invite could not be sent."
    },
    "familyIndex": {
      "memberUpdated": "Member updated.",
      "updateFailed": "Failed to update member."
    },
    "familyShow": {
      "backToFamilyMembers": "Back to Family Members",
      "memberNotFound": "Member Not Found",
      "memberNotFoundMessage": "This family member doesn't exist or you don't have access to it.",
      "tryAgain": "Try again",
      "basicSection": "Basic",
      "fieldRequired": "This field is required.",
      "nameLabel": "Name *",
      "name": "Name",
      "email": "Email",
      "emailVerifiedNote": "Verified through their sign-in account.",
      "emailLoginNote": "Email changes for members with a login aren't available yet.",
      "linkSentTo": "Link sent to {email} — applies once confirmed.",
      "phoneNumber": "Phone Number",
      "dateOfBirth": "Date of Birth",
      "medicalConditions": "Medical Conditions",
      "preferredGenderPronoun": "Preferred Gender Pronoun",
      "detailsSection": "Details",
      "emergencyContactName": "Emergency Contact Name",
      "emergencyPhoneNumber": "Emergency Phone Number",
      "allergies": "Allergies",
      "customFieldsSection": "Custom Fields",
      "familyMemberTitle": "Family Member",
      "loadError": "We could not load this member. Please try again.",
      "profileDetails": "profile details",
      "savedExcept": "Saved, except {fields} — please try again.",
      "saveError": "We could not save your changes. Please try again.",
      "memberSaved": "Member saved."
    }
  },
  "guest": {
    "familyInviteAccept": {
      "acceptYourInvite": "Accept your invite",
      "inviteIntro": "{holder} invited {name} to join {tenant}.",
      "thisInviteIsFor": "This invite is for",
      "signedInDifferentAccount": "You are signed in with a different account. Sign out, then sign in with {email} to accept this invite.",
      "emailAlreadyHasAccount": "This email already has an account. Sign in with {email} to accept this invite.",
      "signInToAccept": "Sign in to accept",
      "signOut": "Sign out",
      "firstName": "First name",
      "fieldRequired": "This field is required.",
      "lastName": "Last name",
      "password": "Password",
      "acceptInvite": "Accept Invite",
      "passwordsMustMatch": "Passwords must match.",
      "acceptFailed": "We could not accept this invite. Please try again.",
      "inviteInvalid": "This invite is invalid or has expired."
    }
  }
}
